import { style, styleVariants } from "@vanilla-extract/css";

import { text } from "~/styles/type.css";
import { vars } from "~/styles/tokens.css";

// Timer digits use the ramp's `numeric` entry — tabular figures so running
// clocks don't jitter. Chip geometry only appears at warning and breach:
// nominal timers are quiet numerals (calm surfaces, loud exceptions).
const base = style([
  text.numeric,
  {
    display: "inline-flex",
    alignItems: "center",
    gap: vars.space.xs,
    whiteSpace: "nowrap",
  },
]);

const chip = style({
  paddingBlock: vars.space["2xs"],
  paddingInline: vars.space.sm,
  borderRadius: vars.radius.md,
});

export const timer = styleVariants({
  nominal: [base, { color: vars.color.textDefault }],
  warning: [
    base,
    chip,
    {
      color: vars.color.timerWarnText,
      backgroundColor: vars.color.timerWarnSurface,
    },
  ],
  // Breach is the one solid red fill in the system — earned by being the
  // thing the product exists to prevent.
  breach: [
    base,
    chip,
    {
      color: vars.color.timerBreachText,
      backgroundColor: vars.color.timerBreachSurface,
    },
  ],
});
